import type { SwiperRef } from 'swiper/react';
import { ImageShape } from '@/types';
import { useRef, MutableRefObject } from 'react';
import { fromCDN } from '@/cdn';
import Image from 'next/image';
import Responsive from '../Responsive';
import { useLazySwiper } from '@/hooks/use-swiper-lazy';
import { useThumbs } from '../ThumbsSlider/ThumbsSlider';

type Props = {
    images: ImageShape[];
    spaceBetween: number;
};

const Slider = ({ images, spaceBetween }: Props) => {
    const { Swiper, SwiperSlide, swiperModules } = useLazySwiper({ useSwiper: true });
    const swiperRef = useRef<SwiperRef>();
    const Thumbs = swiperModules.find((item) => item.name === 'Thumb');
    const { thumbsSwiper } = useThumbs();

    return (
        <Swiper
            modules={Thumbs ? [Thumbs] : []}
            slidesPerView={1}
            ref={swiperRef as MutableRefObject<SwiperRef>}
            spaceBetween={spaceBetween}
            speed={700}
            thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
        >
            {images.map((image, i) => {
                return (
                    <SwiperSlide key={i}>
                        <Responsive className="card-image">
                            <Image
                                loader={({ src, width, quality }) =>
                                    fromCDN(
                                        `/nextapi/optimize?src=${encodeURIComponent(src)}&w=${width}&q=${quality || 80}`,
                                    )
                                }
                                src={image.src}
                                alt=""
                                sizes="(max-width: 767px) 80.55vw, (max-width: 1200px) 37.76vw, (max-width: 1799px) 20.86vw, 18.75vw"
                                itemProp={i === 0 ? 'image' : undefined}
                                layout="fill"
                            />
                        </Responsive>
                    </SwiperSlide>
                );
            })}
        </Swiper>
    );
};

export default Slider;
